import ThemeJson from './theme.color.json'

// 根据二级域名匹配对应主题色
let domainName = location.hostname.split('.')[0]
// let domainName = 'jinyouhui'

let themeItem = ThemeJson[domainName] || ThemeJson['default']

// 设置全局样式变量
for (const key in themeItem) {
  document.documentElement.style.setProperty(key, themeItem[key])
}

// 引入默认element主题样式文件
loadElementCss('/web/static/theme/element/index.css')

// 引入站点单独element主题样式文件
if (themeItem['element-theme-css-url']) {
  loadElementCss(themeItem['element-theme-css-url'])
}

// 引入样式文件函数
function loadElementCss (url) {
  const link = document.createElement('link')
  link.href = url
  link.rel = 'stylesheet'
  document.head.appendChild(link)
}

export default themeItem



// WEBPACK FOOTER //
// ./src/utils/theme_configure/theme.color.js